import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { RootState } from '@cp/src/store';
import { VIEW_REPORT_STATUS_COLUMN_DEFS } from './TableContent';
import { PaginationOptions } from '@cp/src/components/NaviTable/interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';
import NaviTable from '@cp/src/components/NaviTable/NaviTable';
import Loader from '@cp/src/components/Loader/Loader';
import styles from './index.module.scss';
import { getViewReportStatus } from '../action';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';

const ViewReportStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allData = useSelector((state: RootState) => state.teamLeadDashboard.viewReportStatus.data);
  const loading = useSelector(
    (state: RootState) => state.teamLeadDashboard.viewReportStatus.loading
  );

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20
  });
  const [currentPageData, setCurrentPageData] = useState<any[]>([]);

  useEffect(() => {
    dispatch(getViewReportStatus());
  }, []);

  useEffect(() => {
    if (allData) {
      const start = pagination.pageIndex * pagination.pageSize;
      const end = start + pagination.pageSize;
      setCurrentPageData(allData.slice(start, end));
    }
  }, [pagination.pageIndex, pagination.pageSize, allData]);

  const handlePaginationChange = (newPagination: { pageSize: number; pageIndex: number }) => {
    setPagination(newPagination);
  };

  return (
    <div className={styles.reportsContainer}>
      <div className={'flex flex-row items-center gap-2 mb-4'}>
        <div>
          <BackIcon
            className="cursor-pointer"
            size="24"
            color="var(--navi-color-gray-c2)"
            onClick={() => navigate(-1)}
          />
        </div>
        <Typography variant="h1" color="var(--navi-color-gray-c1)">
          Reports
        </Typography>
      </div>

      <NaviTable
        key={pagination.pageSize}
        tableName={'reports'}
        columns={VIEW_REPORT_STATUS_COLUMN_DEFS}
        data={currentPageData}
        totalElements={allData?.length || 0}
        loading={loading}
        showPaginationComponent={(allData?.length || 0) > 20}
        onPaginationChange={handlePaginationChange}
        defaultPaginationState={pagination}
        paginationType={PaginationOptions.SERVER_SIDE}
      />
      <Loader show={loading} className={'overlay'} animate={false} />
    </div>
  );
};

export default ViewReportStatus;
